import { report } from './report';
import { formatUrl, isOa } from '../utils';
import globalWin from '@/utils/globalWin';
const TYPE = 'webim';

function logReport(data, rumReport = true) {
  const url = 'https://fereport.qidian.qq.com/report/imfe?';
  const monitorUrl = 'https://fereport.qidian.qq.com/report/monitor?';
  const { wpaDetail } = globalWin;
  const baseData = {
    ...data,
    visitorid: wpaDetail.visitorid,
    kfuin: wpaDetail.kfuin,
    tid: 'imfe',
    type: TYPE,
    isNewVersion: 'true',
    env: isOa ? 'oa' : 'ol',
  };
  if (typeof roomId) {
    baseData.roomId = window.roomId;
  }
  report(`${formatUrl(url, baseData)}`);
  if (data.message && rumReport) {
    if (!window.__monitor) {
      return;
    }
    const tempMsg = data.message;
    const index = tempMsg.indexOf(',');
    const hasExt = index > 0;
    const name = hasExt ? tempMsg.substring(0, index) : tempMsg;
    const ext1 = hasExt ? tempMsg.substring(index + 1) : '';
    window.__monitor.customerReport(hasExt ? { name, ext1 } : { name });
    const monitorData = { result: 0, ...baseData, event: name };
    report(`${formatUrl(monitorUrl, monitorData)}`);
  }
}

export default logReport;
